<div class="outreach-layout">

  <!-- LEFT: Filters -->
  <aside class="filters-pane">
    <div class="filters-header">Filters</div>

    <div class="filter-group">
      <label class="filter-label">Name</label>
      <input class="filter-input" type="text" [(ngModel)]="nameFilter" placeholder="Search name…" />
    </div>

    <div class="filter-group">
      <label class="filter-label">Exclusive</label>
      <div class="toggle-group">
        <button class="toggle-btn" [class.active]="exclusiveFilter === 'both'" (click)="exclusiveFilter = 'both'">Both</button>
        <button class="toggle-btn" [class.active]="exclusiveFilter === 'yes'"  (click)="exclusiveFilter = 'yes'">Yes</button>
        <button class="toggle-btn" [class.active]="exclusiveFilter === 'no'"   (click)="exclusiveFilter = 'no'">No</button>
      </div>
    </div>

    <div class="filter-group">
      <label class="filter-label">Active</label>
      <div class="toggle-group">
        <button class="toggle-btn" [class.active]="activeFilter === 'both'" (click)="activeFilter = 'both'">Both</button>
        <button class="toggle-btn" [class.active]="activeFilter === 'yes'"  (click)="activeFilter = 'yes'">Yes</button>
        <button class="toggle-btn" [class.active]="activeFilter === 'no'"   (click)="activeFilter = 'no'">No</button>
      </div>
    </div>

    <div class="filter-group">
      <label class="filter-label">Age</label>
      <div class="rate-values">
        <span>{{ minAge }}</span>
        <span>{{ maxAge }}</span>
      </div>
      <div class="range-slider-wrap">
        <div class="range-track">
          <div class="range-fill"
               [style.left.%]="ageMinPct"
               [style.width.%]="ageMaxPct - ageMinPct">
          </div>
        </div>
        <input type="range" class="range-input range-min"
               [min]="0" [max]="AGE_MAX" [step]="AGE_STEP"
               [value]="minAge"
               (input)="onAgeMinChange($event)" />
        <input type="range" class="range-input range-max"
               [min]="0" [max]="AGE_MAX" [step]="AGE_STEP"
               [value]="maxAge"
               (input)="onAgeMaxChange($event)" />
      </div>
    </div>

    <div class="filter-group">
      <label class="filter-label">Single-Video Rate</label>
      <div class="rate-values">
        <span>${{ rateMin | number }}</span>
        <span>${{ rateMax | number }}</span>
      </div>
      <div class="range-slider-wrap">
        <div class="range-track">
          <div class="range-fill"
               [style.left.%]="rateMinPct"
               [style.width.%]="rateMaxPct - rateMinPct">
          </div>
        </div>
        <input type="range" class="range-input range-min"
               [min]="0" [max]="RATE_MAX" [step]="RATE_STEP"
               [value]="rateMin"
               (input)="onRateMinChange($event)" />
        <input type="range" class="range-input range-max"
               [min]="0" [max]="RATE_MAX" [step]="RATE_STEP"
               [value]="rateMax"
               (input)="onRateMaxChange($event)" />
      </div>
    </div>
    <div class="filter-group">
      <label class="filter-label">Genre</label>
      <div class="genre-pills">
        @for (genre of allGenres; track genre) {
          <button class="genre-pill"
                  [class.active]="selectedGenres.has(genre)"
                  (click)="toggleGenre(genre)">{{ genre }}</button>
        }
      </div>
    </div>

  </aside>

  <!-- MIDDLE: Filtered roster -->
  <section class="roster-column">
    <div class="column-header">
      Filtered
      <span class="count-badge">{{ filteredRosters.length }}</span>
      @if (filteredRosters.length > 0) {
        <button class="select-all-btn" (click)="selectAll()">
          Select All
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/>
          </svg>
        </button>
      }
    </div>

    <div class="tiles-scroll filtered-grid">
      @if (loading) {
        <div class="loading-msg">Loading…</div>
      }
      @for (roster of filteredRosters; track roster.id) {
        <div class="roster-tile"
             draggable="true"
             (dragstart)="onFilteredDragStart($event, roster)"
             (dragend)="onDragEnd()"
             title="Drag to select">
          <ng-container *ngTemplateOutlet="tileImg; context: { roster: roster }"></ng-container>
          <div class="tile-text-block">
            <div class="tile-name">{{ roster.name }}</div>
            @if (roster.tiktokHandle) {
              <div class="tile-tiktok">{{ roster.tiktokHandle }}</div>
            }
          </div>
          @if (isAgeFilterActive || isRateFilterActive) {
            <div class="tile-filter-info">
              @if (isAgeFilterActive) {
                <div class="tile-filter-row">Age: {{ getAgeDisplay(roster.birthday) }}</div>
              }
              @if (isRateFilterActive) {
                <div class="tile-filter-row">Rate: {{ roster.tiktokVideoBaseRate ? ('$' + (roster.tiktokVideoBaseRate | number)) : 'Unknown' }}</div>
              }
            </div>
          }
        </div>
      }
      @if (!loading && filteredRosters.length === 0) {
        <div class="empty-msg">No creators match filters.</div>
      }
    </div>
  </section>

  <!-- RIGHT: Selected roster -->
  <section class="roster-column selected-column"
           [class.drop-active]="dropTargetActive"
           (dragover)="onSelectedDragOver($event)"
           (dragleave)="onSelectedDragLeave($event)"
           (drop)="onSelectedDrop($event)">
    <div class="column-header">
      Selected
      <span class="count-badge">{{ selectedRosters.length }}</span>
      @if (selectedRosters.length > 0) {
        <button class="remove-all-btn" (click)="selectedRosters = []">Remove All</button>
        <button class="pitch-btn" (click)="openPitchPage()">View Pitch</button>
      }
    </div>

    <div class="pitch-meta">
      <input class="pitch-meta-input" type="text" [(ngModel)]="pitchTitle" placeholder="Pitch title…" />
      <input class="pitch-meta-input" type="text" [(ngModel)]="pitchBody" placeholder="Pitch description…" />
    </div>

    <div class="tiles-scroll filtered-grid">

      @if (selectedRosters.length === 0 && dropIndex === null) {
        <div class="drop-hint">Drag creators here to select them</div>
      }

      <!-- Placeholder before first card -->
      @if (dropIndex === 0) {
        <div class="card-placeholder"></div>
      }

      @for (roster of selectedRosters; track roster.id; let i = $index) {
        <div class="roster-tile selected-tile"
             [class.drag-ghost]="dragFromSelected && dragRosterId === roster.id"
             draggable="true"
             (dragstart)="onSelectedDragStart($event, roster, i)"
             (dragend)="onDragEnd()">
          <ng-container *ngTemplateOutlet="tileImg; context: { roster: roster }"></ng-container>
          <div class="tile-text-block">
            <div class="tile-name">{{ roster.name }}</div>
            @if (roster.tiktokHandle) {
              <div class="tile-tiktok">{{ roster.tiktokHandle }}</div>
            }
          </div>
          @if (isAgeFilterActive || isRateFilterActive) {
            <div class="tile-filter-info">
              @if (isAgeFilterActive) {
                <div class="tile-filter-row">Age: {{ getAgeDisplay(roster.birthday) }}</div>
              }
              @if (isRateFilterActive) {
                <div class="tile-filter-row">Rate: {{ roster.tiktokVideoBaseRate ? ('$' + (roster.tiktokVideoBaseRate | number)) : 'Unknown' }}</div>
              }
            </div>
          }
          <button class="remove-btn" (click)="removeSelected(roster.id)" title="Remove">✕</button>
        </div>
        <!-- Placeholder after this card -->
        @if (dropIndex === i + 1) {
          <div class="card-placeholder"></div>
        }
      }

    </div>
  </section>

</div>

<!-- Shared image template -->
<ng-template #tileImg let-roster="roster">
  @if (imgSrc(roster)) {
    <img class="tile-img"
         [src]="imgSrc(roster)!"
         [alt]="roster.name"
         (error)="onImgError($event, roster)" />
  } @else {
    <div class="tile-img tile-img-empty"></div>
  }
</ng-template>
